import { useState, useEffect } from 'react';
import {
    FormHelperText, FormLabel, FormControl, TextField,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    AccordionSetup,
} from '@commonClient2/components';
import { UPDATE_GLOBAL_SETUP } from '../../store/globalSetup';

import './EmployeeDisplayPreferences.scss';

/**
 * @param {{
 *  isDisabled?: boolean;
 *  isLoading: boolean;
 *  globalSetups: GlobalSetup.GlobalSetup;
 *  globalSetupsToReset: GlobalSetup.GlobalSetup;
 *  step: number;
 * }} param0
 * */
const EmployeeDisplayPreferencesSettings = ({
    isLoading,
    globalSetups,
    step,
}) => {
    const { t } = useTranslation('globalSetup', { keyPrefix: 'employeeDisplayPreferences' });
    const dispatch = useDispatch();
    const { employeeDisplayPreferences: rules } = globalSetups;

    const {
        employeeDisplayOrganizationalPathLength,
    } = rules;

    const [eeOrgPathLength, setOrgPathLength] = useState(employeeDisplayOrganizationalPathLength);

    /**
     * @template T
     * @param {T} value
     */
    const updateStore = (value) => {
        dispatch({
            type: UPDATE_GLOBAL_SETUP,
            payload: { employeeDisplayPreferences: value },
        });
    };

    /**
     * @param {string} field
     * @param {*} value
     */
    const onChange = (field, value) => updateStore({ ...rules, [field]: value });

    useEffect(() => { setOrgPathLength(employeeDisplayOrganizationalPathLength); }, [JSON.stringify(rules)]);

    return (
        <AccordionSetup
            stepIndex={step.toString()}
            headerTitle={t('title')}
            summary=""
            className="employees-display-preferences-step"
        >
            <div className="employee-organizational-path-length">
                <FormControl>
                    <FormLabel id="employee-organizational-path-length-label">{t('employeeOrganizationalPathLength')}</FormLabel>
                    <div>
                        <TextField
                            name="employeeDisplayOrganizationalPathLength"
                            className="employee-organizational-path-input"
                            aria-labelledby="employee-organizational-path-length-label"
                            value={eeOrgPathLength}
                            onChange={({ target: { value } }) => {
                                const valueAsNumber = Number(value);
                                onChange('employeeDisplayOrganizationalPathLength', valueAsNumber);
                                setOrgPathLength(valueAsNumber);
                            }}
                            variant="outlined"
                            size="small"
                            inputProps={{
                                min: 1,
                                max: 20,
                                required: true,
                            }}
                            type="number"
                            disabled={isLoading}
                        />
                    </div>
                </FormControl>
                <FormHelperText>{t('employeeOrganizationalPathLengthHint')}</FormHelperText>
            </div>
        </AccordionSetup>
    );
};

export default EmployeeDisplayPreferencesSettings;
